import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Combobox} from '@ariakit/react'
import styled, {css} from 'styled-components'

export const StyledCommandMenuInputWrapper = styled(Flexbox)(
    ({theme: {palette, spacing}}) => css`
        padding: ${spacing * 2}px ${spacing * 4}px;
        outline: 1px solid ${palette.neutral[100]};
        background: ${palette.neutral.white};
        backdrop-filter: blur(4px);
        border-radius: 8px 8px 0 0;
        width: 100%;
        max-width: 640px;
        color: ${palette.neutral[500]};
        height: 56px;
    `
)

export const StyledCommandMenuDismissButton = styled(Button)`
    white-space: nowrap;
`

export const StyledCommandMenuCombobox = styled(Combobox)(
    ({theme: {typography, palette}}) => css`
        ${typography.textMd};
        color: ${palette.neutral[950]};
        width: 100%;
    `
)
